import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'

interface Props {
  label: ReactNode
  description?: ReactNode
  children?: ReactNode
}
const InputTitle = ({ label, description, children }: Props) => (
  <Box paddingY={1}>
    <Box display="flex" alignItems="flex-end">
      <Box paddingRight={2}>
        <Typography variant="subtitle2">{label}</Typography>
      </Box>
      <Typography variant="caption" color="textSecondary">
        {description}
      </Typography>
    </Box>
    {children}
  </Box>
)

export default InputTitle
